module.exports = __webpack_public_path__ + "static/media/long-term.7052ba6e.png";